const React = require('react')
const { Col, Row } = require('reactstrap')
const { TablePagination } = require('./pagination.table')
const { useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/components/table/footer.table.css')

const TableFooterWithoutLimit = ({ page, limit, totalPages }) => {
    const isMobile = useResponsive(BREAKPOINTS.small)

    return (
        <>
            <Row className='table-footer-row'>
                {!isMobile && (
                    <Col className='d-flex justify-content-end'>
                        <TablePagination page={page} limit={limit} totalPages={totalPages} />
                    </Col>
                )}
            </Row>
            {isMobile && (
                <Row style={{ paddingBottom: '16px' }}>
                    <Col>
                        <TablePagination page={page} limit={limit} totalPages={totalPages} />
                    </Col>
                </Row>
            )}
        </>
    )
}

module.exports = { TableFooterWithoutLimit }
